<router-outlet></router-outlet>

<div
    *ngIf="showUpdatePrompt"
    class="update-overlay"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="update-title"
    aria-describedby="update-description"
>
    <div class="update-modal">
        <h2 id="update-title">Nova versão disponível</h2>
        <p id="update-description">
            Detectamos uma atualização obrigatória do aplicativo. Clique em "Atualizar agora" para carregar a versão mais recente e liberar os novos recursos.
        </p>
        <div class="update-meta" *ngIf="availableVersion">
            <span>Versão disponível: {{ availableVersion }}</span>
        </div>
        <button type="button" (click)="reloadApp()">Atualizar agora</button>
    </div>
</div>
